import { render, staticRenderFns } from "./FinancePayoutsKindSection.vue?vue&type=template&id=428b07c7&"
import script from "./FinancePayoutsKindSection.vue?vue&type=script&lang=js&"
export * from "./FinancePayoutsKindSection.vue?vue&type=script&lang=js&"
import style0 from "./FinancePayoutsKindSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports